<template>
  <div class="tags-view-container">
    <div class="tags-wrapper">
    
      <span
        v-for="tag in visitedViews"
        :key="tag.fullPath"
        class="tag-item"
        :class="{ active: isActive(tag) }"
        @click="go(tag)"
        @contextmenu.prevent="openContextMenu($event, tag)"
      >
        <!-- 自动匹配图标 -->
        <i
          :class="getIcon(tag.title)"
          style="margin-right:5px; font-size:14px;"
        ></i>
        {{ tag.title }}
        <i
          v-if="tag.name !== 'home'"
          class="el-icon-close tag-close"
          @click.stop="closeTag(tag)"
        />
      </span>
    </div>

    <div
      class="context-menu"
      v-show="contextVisible"
      :style="{ left: contextX + 'px', top: contextY + 'px' }"
    >
      <div class="context-item" @click="closeCurrent">关闭当前</div>
      <div class="context-item" @click="closeOther">关闭其他</div>
      <div class="context-item" @click="closeAll">关闭所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagsView",
  data() {
    return {
      contextVisible: false,
      contextX: 0,
      contextY: 0,
      currentTag: null
    };
  },
  computed: {
    visitedViews() {
      return (this.$store && this.$store.state.tagsView)
        ? this.$store.state.tagsView.visitedViews
        : [];
    },
  },
  watch: {
    $route() {
      this.addTag();
    },
  },
  mounted() {
    this.addTag();
    document.addEventListener("click", () => this.contextVisible = false);
  },
  methods: {
    // 根据标题自动匹配图标
    getIcon(title) {
      const map = {
        "应用管理": "el-icon-s-grid",
              "用户管理": "el-icon-user",
              "菜单管理": "el-icon-menu",
              "角色管理": "el-icon-s-custom",
              "日志管理": "el-icon-document",
          
              "实时订单": "el-icon-s-marketing",
              "订单查看": "el-icon-view",
              "预约订单": "el-icon-date",
              "订单随车人员记录": "el-icon-user",
              "订单其他费用记录": "el-icon-s-finance",
              "订单用药记录": "el-icon-medicine-box",
              "订单支付记录": "el-icon-money",
              "订单退款记录": "el-icon-refresh",
              "订单统计管理": "el-icon-data-line",
          
              "机构信息管理": "el-icon-info",
        //       "机构车辆管理": "el-icon-car",
        		// "机构分成管理": "el-icon-car",
          
              // "车辆信息管理": "el-icon-car",
              "车主管理": "el-icon-user",
              "车辆历史状态信息": "el-icon-time",
              "车辆上下线状态信息管理": "el-icon-switch-button",
              "车辆年检信息管理": "el-icon-document",
              "车辆维修信息管理": "el-icon-wrench",
              "车辆保险信息管理": "el-icon-s-help",
              // "车辆消毒管理": "el-icon-medicine-box",
          
              "车载设备信息管理": "el-icon-set-up",
              "车载设备入库记录": "el-icon-upload2",
              "车载设备库存记录": "el-icon-s-grid",
              "车载设备出库记录": "el-icon-download",
              "车载设备维修管理": "el-icon-wrench",
              "车载设备报废管理": "el-icon-delete",
              "车载硬盘数据备份记录管理": "el-icon-document-copy",
              // "医用设备（含药品）信息管理": "el-icon-document-add",
          
              "随车人员实时状态管理": "el-icon-video-camera",
              "随车人员历史状态管理": "el-icon-time",
              "随车人员证书信息管理": "el-icon-document",
          
              "证书信息管理": "el-icon-document",
              "随车人员证书管理": "el-icon-document",
              "随车人员培训记录管理": "el-icon-reading",
              "随车人员培训科目信息": "el-icon-reading",
          
              // "转运类型管理": "el-icon-s-cooperation",
              "转运车类型管理": "el-icon-data-line",
              "转运收费标准管理": "el-icon-money",
              "转运预付费管理": "el-icon-money",
              "调度员区域关联管理": "el-icon-location",
              "车辆与车载关联管理": "el-icon-link",
          
              "驾驶员管理": "el-icon-coordinate",
              "医护人员管理": "el-icon-user-solid",
              "随车人员历史状态信息": "el-icon-time",
              "随车人员上下线状态信息管理": "el-icon-switch-button",
			  
			  "订单调度": "el-icon-s-order",
			  "历史调度":"el-icon-time"
      };
      return map[title] || "el-icon-document";
    },
    isActive(route) {
      return route.fullPath === this.$route.fullPath;
    },
    addTag() {
      if (!this.$route.meta.title) return;
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
    },
    go(tag) {
      this.$router.push(tag.fullPath);
    },
    closeTag(tag) {
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/delView", tag).then(() => {
          if (this.isActive(tag)) {
            const last = this.visitedViews[this.visitedViews.length - 1];
            if (last) this.$router.push(last.fullPath);
          }
        });
      }
    },

    openContextMenu(e, tag) {
      this.currentTag = tag;
      this.contextX = e.clientX;
      this.contextY = e.clientY;
      this.contextVisible = true;
    },
    closeCurrent() {
      if (!this.currentTag) return;
      this.closeTag(this.currentTag);
      this.contextVisible = false;
    },
    closeOther() {
      const keep = this.currentTag;
      this.$store.state.tagsView.visitedViews = [keep];
      this.go(keep);
      this.contextVisible = false;
    },
    closeAll() {
      this.$store.state.tagsView.visitedViews = [];
      this.contextVisible = false;
    },
  },
};
</script>

<style scoped>
.tags-view-container {
  height: 100%;
  line-height: 100%;
  background: transparent;
  border: none;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

.tags-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

.tags-wrapper::-webkit-scrollbar {
  height: 4px;
}
.tags-wrapper::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
.tags-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.tag-item {
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.tag-item.active {
  background: #409eff;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.tag-item:hover:not(.active) {
  background: #e8f4ff;
}

.tag-close {
  font-size: 11px;
  margin-left: 6px;
  opacity: 0.8;
}
.tag-close:hover {
  opacity: 1;
}

.context-menu {
  position: fixed;
  z-index: 99999;
  width: 150px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding: 6px 0;
}
.context-item {
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.context-item:hover {
  background: #409eff !important;
  color: #fff !important;
}
</style>